import React, { useState, useEffect } from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import { message } from 'antd'; 
import { Auth } from '../../utils/Auth';
import { commissionApi } from '../../api/commissionApi';


const UpdateCommissionView = () => {
    const abortController = new AbortController()
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        percentage: "",
        description: "",
    });
    
    const user = Auth.getUser()

  // Récupérer le profil de l'administrateur connecté
  const loadData = async () => {
    try {
        const res = await commissionApi.showCommission(1,abortController.signal);
        // Supposez que cette méthode existe pour récupérer le profil
        console.log(res.data)
        if (res && res.data) {
            setFormData({
            percentage: res.data.percentage,
            description: res.data.description
            });
            setLoading(false);
        } else {
            message.error("Impossible de récupérer la commission");
            setLoading(false);
        }
        } catch (error) {
            setLoading(false);
            message.error("Erreur lors de la recuperation de la commission.");
        }
  };

  // Charger les données au démarrage du composant
  useEffect(() => {
    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Soumettre le formulaire de modification de profil
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        const payload = {
            percentage: formData.percentage,
            description: formData.description || '',
        };
        console.log("Payload envoyé:", payload)

      const res = await commissionApi.updateCommission(JSON.stringify(payload),abortController.signal); 
      if (res && res.data) {
        message.success("Commission mise à jour avec succès");
      } else {
        message.error("Échec de la mise à jour de la commission");
      }
    } catch (error) {
      message.error("Erreur lors de la mise à jour de la commission");
      console.log(error)
    }
    setLoading(false);
  };

 

  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Volet Profil */}
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-2xl font-semibold mb-4">Parametrage de la commission</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Pourcentage de la commission (%)</label>
                <input
                  type="text"
                  name="percentage"
                  placeholder='10'
                  value={formData.percentage}
                  onChange={(handleChange)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loading}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loading}
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
                disabled={loading}
              >
                {loading ? 'Chargement...' : 'Mettre à jour la commission'}
              </button>
            </form>
          </div>

          {/* Volet Mot de passe */}
          
        </div>
      </div>
    </MainLayout>
  );
};

export default UpdateCommissionView;
